<template>
	<div>

				<div class="form-horizontal">
				<div class="form-group">
					<label for='payment_date' class="control-label">Date</label>
					<div class="input-group">
						<el-date-picker 
							v-model="selectedDate" 
							v-on:change="getTrainingSessions"
							format="dd/MM/yyyy" 
							value-format="yyyy-MM-dd"
							:default-value="today"
							:pickerOptions="{firstDayOfWeek: 1}" 
							type="date" 
							id="selected_date" 
							name="selected_date" 
							placeholder='dd/mm/yyyy'></el-date-picker>
					</div>
			</div>
		</div>

		<div class="row">
			<div class="panel panel-primary">
				<div class="panel-heading">Training Sessions</div>
					<table class="table">
						<thead>
							<tr>
								<th class="" v-show="useSessionNames == true">Session Name</th>
								<th class="visible-xs visible-sm" v-show="useSessionNames == false">Session</th>
								<th class="hidden-xs hidden-sm">Location</th>
								<th class="hidden-xs hidden-sm">Squads</th>
								<th class="hidden-xs hidden-sm">Groups</th>
								<th class="hidden-xs hidden-sm">Type</th>
								<th class="hidden-xs hidden-sm">Time</th>
								<th>&nbsp;</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(trainingSession, index) in trainingSessions" v-show="selectedTrainingSessionIndex == null || selectedTrainingSessionIndex == index">
                                <th v-show="useSessionNames == true">{{ trainingSession.training_session_name }}</th>
								<th v-show="useSessionNames == false" class="visible-xs visible-sm">{{ trainingSession.location.name }}<br /><small>{{ trainingSession.squad_names}}&nbsp;{{ trainingSession.group_names}} {{ trainingSession.type}}&nbsp;{{ trainingSession.time }}</small></th>
								<td class="hidden-xs hidden-sm">{{ trainingSession.location.name }}</td>
								<td class="hidden-xs hidden-sm">{{ trainingSession.squad_names}}</td>
								<td class="hidden-xs hidden-sm">{{ trainingSession.group_names}}</td>
								<td class="hidden-xs hidden-sm">{{ trainingSession.type}}</td>
								<td class="hidden-xs hidden-sm">{{ trainingSession.time }}</td>
								<td>
									<button class="btn btn-primary btn-sm" v-show="selectedTrainingSessionIndex == null" v-on:click="selectTrainingSession(index)">Take Attendance</button>
									<button class="btn btn-success btn-sm" v-show="selectedTrainingSessionIndex == index" v-on:click="saveAll()">Save</button>
									<button class="btn btn-danger btn-sm" v-show="selectedTrainingSessionIndex == index" v-on:click="cancelChanges()">Cancel</button>

								</td>
							</tr>
						</tbody>
					</table>
				<div class="panel-body" v-if="selectedTrainingSessionDate != null">
					<div class="row">
						<div class="col-xs-12">
							<div class="form-group">
								<label for="session_cancelled">Session Status</label>
								<el-switch
								  v-model="selectedTrainingSessionDate.cancelled"
								  @input="saveTrainingSessionDate();"
								  class="form-control"
								  id="session_cancelled"
								  active-color="#F56C6C"
								  inactive-color="#67C23A"
								  active-text="Cancelled"
								  inactive-text="Not Cancelled">
								</el-switch>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="form-group">
								<label>Coach / Teacher</label>
								<member-select v-model="selectedCoachIds" @input="saveTrainingSessionDate();" role_type="Coaching Staff|Teaching Staff" :multiple="true"></member-select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="form-group">
								<label>Lifeguard</label>
								<member-select v-model="selectedLifeguardIds" @input="saveTrainingSessionDate();" role_type="Lifeguard" :multiple="true"></member-select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<div class="form-group">
								<label>Workouts</label>
								<workout-select v-model="selectedWorkoutIds" :multiple="true" @input="loadWorkouts();saveTrainingSessionDate();"></workout-select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="form-group">
								<textarea id="workout" placeholder="Workout details will be displayed here" rows="5" @click="copyWorkout" class="form-control tabbable-textarea disabled" disabled v-model="workoutDisplay"></textarea>
								<p class="small text-info" @click="copyWorkout">Click here to copy to clipboard</p>

							</div>
						</div>
					</div>
					
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div class="form-group">
								<label for="session_note">Session Notes</label>
								<textarea id="session_note" placeholder="Enter training notes or set details" rows="5" class="form-control tabbable-textarea" v-model="selectedTrainingSessionDate.note"></textarea>

							</div>
						</div>
					</div>


				</div>

			</div>
		</div>

		<vuedal></vuedal>
		<div class="row" v-show="trainingSessionMembers.length > 0">
			<div class="panel panel-info">
				<div class="panel-heading clearfix">
					<span class="panel-title">Swimmers</span>
					<span class="form-inline pull-right">
						<div class="form-group" v-if="selectedTrainingSessionDate != null && selectedTrainingSessionDate.groups.length > 1">
							<label class="control-label">Group</label>
							<select class="form-control input-sm" v-model="filterGroupId">
								<option value="0">All</option>
								<option v-for="(group, index) in selectedTrainingSessionDate.groups" :value="group.id">{{ group.name }}</option>
							</select>
						</div>
						<div class="form-group" v-if="selectedTrainingSessionDate != null && selectedTrainingSessionDate.squads.length > 1">
							<label class="control-label">Squad</label>
							<select class="form-control input-sm" v-model="filterSquadId">
								<option value="0">All</option>
								<option v-for="(squad, index) in selectedTrainingSessionDate.squads" :value="squad.id">{{ squad.name }}</option>
							</select>
						</div>
					</span>
				</div>
				<table class="table table-bordered table-striped table-condensed">
					<thead>
						<tr>
							<th>Member</th>
							<th class="hidden-xs hidden-sm visible-md visible-lg">Squad</th>
							<th>Attendance</th>
							<th>Note</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(trainingSessionMember, index) in trainingSessionMembers" v-show="showMember(trainingSessionMember)" >
							<td class="member-name visible-xs visible-sm hidden-md hidden-lg">{{ trainingSessionMember.member.name }}<span v-if="trainingSessionMember.member.squad !== null"><br /><small>{{ trainingSessionMember.member.squad.name }}</small></span><span v-if="trainingSessionMember.member.medical_information !== ''"><br /><button class="btn btn-warning" @click="showMemberMedicalDetails(trainingSessionMember.member)"><span class="glyphicon glyphicon-heart-empty"></span></button></span></td>
							<td class="member-name hidden-xs hidden-sm visible-md visible-lg">{{ trainingSessionMember.member.name }}<button v-if="trainingSessionMember.member.medical_information !== ''" class="btn btn-warning pull-right" @click="showMemberMedicalDetails(trainingSessionMember.member)"><span class="glyphicon glyphicon-heart-empty"></span></button></td>
							<td class="member-name hidden-xs hidden-sm visible-md visible-lg"><span v-if="trainingSessionMember.member.squad !== null">{{ trainingSessionMember.member.squad.name }}</span></td>
							<td>


								<div class="btn-group" style="display:flex;">
									<button type="button" class="btn" aria-expanded="false" v-on:click="toggleAttendanceStatus(trainingSessionMember)" v-bind:class="{ 'btn-warning': ['75%', '50%', '25%'].indexOf(trainingSessionMember.status) != -1, 'btn-info': ['Excused'].indexOf(trainingSessionMember.status) != -1, 'btn-success active': ['100%'].indexOf(trainingSessionMember.status) != -1, 'btn-danger': ['Absent', 'Sick', '0%'].indexOf(trainingSessionMember.status) != -1}">{{ trainingSessionMember.status }}</button>
									<button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"  v-bind:class="{ 'btn-warning': ['75%', '50%', '25%'].indexOf(trainingSessionMember.status) != -1, 'btn-info': ['Excused'].indexOf(trainingSessionMember.status) != -1, 'btn-success active': ['100%'].indexOf(trainingSessionMember.status) != -1, 'btn-danger': ['Absent', 'Sick', '0%'].indexOf(trainingSessionMember.status) != -1}">
										<span class="caret"></span>
									</button>
									<ul class="dropdown-menu">
										<li class="bg-warning text-warning"><a href="#" v-on:click="setAttendanceStatus(trainingSessionMember, '75%')">75%</a></li>
										<li class="bg-warning text-warning"><a href="#" v-on:click="setAttendanceStatus(trainingSessionMember, '50%')">50%</a></li>
										<li class="bg-warning text-warning"><a href="#" v-on:click="setAttendanceStatus(trainingSessionMember, '25%')">25%</a></li>
										<li class="bg-danger text-danger"><a href="#" v-on:click="setAttendanceStatus(trainingSessionMember, 'Excused')">Excused</a></li>
										<li class="bg-danger text-danger"><a href="#" v-on:click="setAttendanceStatus(trainingSessionMember, 'Sick')">Sick</a></li>
									</ul>
								</div>	

								<span class="text-success" v-show="trainingSessionMember.savedSuccess === true "><span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span></span>
								<span class="text-danger" v-show="trainingSessionMember.savedSuccess === false " v-on:click="saveTrainingSessionMember(trainingSessionMember)"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true" data-toggle="tooltip" data-placement="top" title="There was a problem saving this attendance - click here to try again"></span></span>
							</td>
							<td>
								<input type="text" v-model="trainingSessionMember.note" class="form-control"/>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

	</div>
</template>

<style scoped>
	.member-name {
		font-size: 120%;
	}
</style>

<script>

import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
import lang from 'element-ui/lib/locale/lang/en';
import locale from 'element-ui/lib/locale';
import { default as Vuedals, Component as Vuedal, Bus as VuedalsBus } from 'vuedals';
locale.use(lang);
	Vue.use(Vuedals);

export default {
	components: { DatePicker, Message, Tooltip, Icon, Loading, Vuedal },
	props: {
		'useSessionNames': {
			type: Boolean,
			default: false
		},
	},
	data: function () {
		return {
			selectedDate: null,
			selectedTrainingSessionIndex: null,
			selectedTrainingSessionDate: null,
			selectedCoachIds: [],
			selectedLifeguardIds: [],
			selectedWorkoutIds: [],
			workoutDetails: '',
			trainingSessions: [],
			trainingSessionMembers: [],
			memberAttendance: [],
			loading: false,
			filterSquadId: 0,
			filterGroupId: 0,
			datePickerOptions: {

			},
			attendance_options: ['100%','Absent','Excused','Sick','25%','50%','75%']
		}
	},
	computed: {
		today: function() {
			return moment().tz('Europe/London').format('YYYY-MM-DD');
		},
		workoutDisplay: function() {
			if (this.workoutDetails) {
				let w = this.workoutDetails.map((workout) => {
					return workout.details;
				});
				return w.join("\r\n");
			}
		}
	},
	mounted() {
		console.log('Attendance component mounted.');
		this.setupDefaults();
		this.getTrainingSessions();
	},
	methods: {
		setupDefaults() {
			console.log('Setting defaults');
			this.selectedDate = moment().tz('Europe/London').format('YYYY-MM-DD');
		},
		getNextStatus(currentStatus) {
			var currentIndex = this.attendance_options.indexOf(currentStatus);
			if ( (currentIndex + 1) == this.attendance_options.length) {
				return this.attendance_options[0];
			}
			else {
				return this.attendance_options[currentIndex+1];
			}
		},
		cycleAttendanceStatus(training_session_member) {
			var newStatus = this.getNextStatus(training_session_member.status);
			training_session_member.status = newStatus;
			training_session_member.percentage = parseInt(newStatus,10) || 0; // Prevents NaN for parsing pure string without numbers
			this.saveTrainingSessionMember(training_session_member)
		},
		toggleAttendanceStatus(training_session_member) {
			var newStatus;
			if (training_session_member.status == '100%') {
				training_session_member.status='Absent';
			}
			else {
				training_session_member.status='100%';
			}
			this.saveTrainingSessionMember(training_session_member);
		},
		setAttendanceStatus(training_session_member, newStatus) {
			console.log('setAttendanceStatus');
			console.log('Setting attendance to ' + newStatus)
			training_session_member.status = newStatus;
			this.saveTrainingSessionMember(training_session_member)
		},
		getTrainingSessions() {
			console.log('getTrainingSessions.');
			console.log(this.selectedDate);
			this.cancelChanges();
			this.trainingSessions = [];
			var dow= moment(this.selectedDate, "YYYY-MM-DD").format("E");
			axios.get('/api/v1/training_sessions?filters=day_of_week:' + dow ).then((response) => {
				console.log(response.data);
				this.trainingSessions = response.data;
			}).catch((error) => {
				this.$message({message: 'There was a problem loading training sessions.', type: 'error'});
			});
		},
		selectTrainingSession(index) {
			console.log('selectTrainingSession.');

			this.selectedTrainingSessionIndex = index;

			console.log(this.selectedDate);

			var training_date= moment(this.selectedDate, "YYYY-MM-DD").format("YYYY-MM-DD");
			axios.get('/api/v1/training_session/' + this.trainingSessions[this.selectedTrainingSessionIndex].id + '/' + training_date).then((response) => {
				console.log(response.data);
				this.selectedTrainingSessionDate = response.data;
				this.selectedCoachIds = _.map(response.data.coaches, 'id');
				this.selectedLifeguardIds = _.map(response.data.lifeguards, 'id');
				this.selectedWorkoutIds = _.map(response.data.workouts, 'id');
				this.getTrainingSessionAttendance(this.trainingSessions[this.selectedTrainingSessionIndex]);
			}).catch((error) => {
				this.$message({message: 'There was a problem loading training session for the selected date.', type: 'error'});
			});

		},
		getTrainingSessionAttendance(trainingSession) {
			console.log('getTrainingSessionAttendance.');
			console.log(this.selectedDate);
			var training_date= moment(this.selectedDate, "YYYY-MM-DD").format("YYYY-MM-DD");
			axios.get('/api/v1/training_session/' + trainingSession.id + '/' + training_date + '/attendance').then((response) => {
				console.log(response.data);
				this.trainingSessionMembers = response.data;
			}).catch((error) => {
				this.$message({message: 'There was a problem retrieving the attendance for this training session.', type: 'error'});
			});
		},
		cancelChanges() {
			console.log('cancelChanges.');
			this.selectedTrainingSessionIndex = null;
			this.selectedTrainingSessionDate = null;
			this.trainingSessionMembers = [];
		},
		saveAll() {
			console.log('saveAll.');
			this.saveTrainingSessionDate();
			this.saveTrainingSessionMembers();
		},
		saveTrainingSessionDate() {
			console.log('saveTrainingSession.');
			var data = this.selectedTrainingSessionDate;
			data.lifeguard_id = this.selectedLifeguardIds;
			data.coach_id = this.selectedCoachIds;
			data.workout_id = this.selectedWorkoutIds;
			axios.put('/api/v1/training_session_date/' + this.selectedTrainingSessionDate.id, 
				data,
			).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.$message({message: 'The training session details were saved successfully.', type: 'success'});

			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem saving the training session details.', type: 'error'});
			});
		},
		saveTrainingSessionMembers() {
			console.log('saveTrainingSessionMembers.');
			axios.put('/api/v1/training_session/' + this.selectedTrainingSessionDate.training_session.id + '/' + this.selectedDate + '/attendance', {
				training_session_members: this.trainingSessionMembers,
			}).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);
				this.$message({message: 'The training session attendance was saved successfully.', type: 'success'});

			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$message({message: 'There was a problem saving the training session attendance.', type: 'error'});
			});
		},
		saveTrainingSessionMember(training_session_member) {
			console.log('saveTrainingSessionMembers.');
			this.$set(training_session_member, 'savedSuccess', null);
			axios.put('/api/v1/training_session_member/' + training_session_member.id, {
				training_session_member,
			}).then((response) => {
				// this.loadingInstance.close();
				console.log(response.data);

				this.$set(training_session_member, 'savedSuccess', true);
				setTimeout(() => {
					this.$set(training_session_member, 'savedSuccess', null);
					// training_session_member.savedSuccess = null;
				}, 2000);
				// this.$message({message: 'The training session attendance for ' + training_session_member.member.name + ' was saved successfully.', type: 'success'});

			}).catch((error) => {
				// this.loadingInstance.close();
				this.handleHTTPError(error);
				this.$set(training_session_member, 'savedSuccess', false);
				// this.$message({message: 'There was a problem saving the training session attendance for ' + training_session_member.member.name, type: 'error'});
			});
		},
        showMemberMedicalDetails(member) {
        	console.log('showMemberMedicalDetails');
        	console.log('Member ID: ' + member.id);
        	console.log(member);
        	this.$vuedals.$emit('new', {
                name: 'medical-information',
                title: member.name,
                size: 'xs',
                props: {
                    member: member
                },
                component: 'member-medical-popup'
            });
        },
		handleHTTPError(error) {
				if (error.response) {
					// The request was made and the server responded with a status code
					// that falls out of the range of 2xx
					console.log(error.response.data); // Error message
					console.log(error.response.status);
					console.log(error.response.headers);
					// this.$message({message: 'Error: ' + error.response.data, type: 'error'});
				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
					// this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					// this.$message({message: 'There was a problem updating the team - please try again.', type: 'error'});
				}
				console.log(error.config);
		},
		loadWorkouts() {
			console.log('Workout details loading');
			axios.get('/api/v1/workouts?filters=id:' + this.selectedWorkoutIds.join('|')).then((response) => {
				console.log(response.data);
				this.workoutDetails = response.data;
			}).catch((error) => {
				this.$message({message: 'There was a problem loading the workout details.', type: 'error'});
			});

		},
		copyWorkout() {
			navigator.clipboard.writeText(this.workoutDisplay);
			this.$message({message: 'Workout details have been copied', type: 'success'});
		},
		showMember(trainingSessionMember)
		{
			return (
					this.filterSquadId == 0 &&
					this.filterGroupId == 0
					) || 
					(
						this.filterSquadId == 0 ||
						((trainingSessionMember.member.squad != null) && 
						(trainingSessionMember.member.squad.id == this.filterSquadId))
					)
					&&
					(
						this.filterGroupId == 0 ||
						((trainingSessionMember.member.groups != null) &&
						(_.findIndex(trainingSessionMember.member.groups,  (group) => {
							console.log(`Checking group id ${group.id} against filter ${this.filterGroupId}`);
								return group.id == this.filterGroupId;
							}) >= 0)
						)
					);
		}
	}
}
</script>